// extracted by mini-css-extract-plugin
module.exports = {"grid":"CollectionGrid_grid__3Zyv_","gridItem":"CollectionGrid_gridItem__GOFvG"};